// Structural data for MyCleaner.ch (text content lives in i18n.js)
export const BRAND = "MyCleaner.ch";
export const HOURLY_RATE = 43.9; // CHF pro Stunde / per hour, Fixpreis
export const LOGO = "/logo-mycleaner.png";

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1758273705627-937374bfa978",
  working: "https://images.pexels.com/photos/7513048/pexels-photo-7513048.jpeg",
  about: "https://images.pexels.com/photos/9462192/pexels-photo-9462192.jpeg",
  kitchen: "https://images.unsplash.com/photo-1556911220-bff31c812dba?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxjbGVhbiUyMGtpdGNoZW58ZW58MHx8fHwxNzg3MTE2NjgyfDA&ixlib=rb-4.1.0&q=85",
  bathroom: "https://images.unsplash.com/photo-1620626011761-996317b8d101?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHw0fHxiYXRocm9vbXxlbnwwfHx8fDE3ODcxMTY2ODJ8MA&ixlib=rb-4.1.0&q=85",
  living: "https://images.unsplash.com/photo-1583847268964-b28dc8f51f92?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxsaXZpbmclMjByb29tfGVufDB8fHx8MTc4NzExNjY4Mnww&ixlib=rb-4.1.0&q=85",
  supplies: "https://images.pexels.com/photos/5217889/pexels-photo-5217889.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const contactInfo = {
  phone: "+41 44 688 03 80",
  phoneHref: "tel:+41446880380",
  email: "info@mycleaner.ch",
};

// Cities for local SEO pages
export const cities = [
  { slug: "zuerich", name: "Zürich", canton: "ZH", quarters: ["Altstadt", "Oerlikon", "Wiedikon", "Enge", "Seefeld", "Aussersihl"] },
  { slug: "zug", name: "Zug", canton: "ZG", quarters: ["Altstadt", "Guthirt", "Herti", "Oberägeri", "Baar", "Cham"] },
  { slug: "luzern", name: "Luzern", canton: "LU", quarters: ["Altstadt", "Tribschen", "Maihöf", "Littau", "Emmenbrücke", "Kriens"] },
  { slug: "baden", name: "Baden", canton: "AG", quarters: ["Altstadt", "Kappelerhof", "Dättwil", "Wettingen", "Ennetbaden", "Neuenhof"] },
  { slug: "bern", name: "Bern", canton: "BE", quarters: ["Altstadt", "Länggasse", "Breitenrain", "Bümpliz", "Kirchenfeld", "Wankdorf"] },
  { slug: "basel", name: "Basel", canton: "BS", quarters: ["Kleinbasel", "Grossbasel", "Gundeldingen", "St. Johann", "Riehen", "Allschwil"] },
  { slug: "genf", name: "Genf", nameEn: "Geneva", canton: "GE", quarters: ["Eaux-Vives", "Plainpalais", "Champel", "Servette", "Carouge", "Meyrin"] },
  { slug: "lausanne", name: "Lausanne", canton: "VD", quarters: ["Flon", "Ouchy", "Chailly", "Prilly", "Renens", "Pully"] },
  { slug: "winterthur", name: "Winterthur", canton: "ZH", quarters: ["Altstadt", "Töss", "Oberwinterthur", "Seen", "Wülflingen", "Veltheim"] },
  { slug: "st-gallen", name: "St. Gallen", canton: "SG", quarters: ["Innenstadt", "St. Fiden", "Bruggen", "Rotmonten", "Lachen", "Winkeln"] },
  { slug: "aarau", name: "Aarau", canton: "AG", quarters: ["Altstadt", "Rohr", "Suhr", "Buchs", "Kölliken", "Unterentfelden"] },
  { slug: "thun", name: "Thun", canton: "BE", quarters: ["Innenstadt", "Lerchenfeld", "Dürrenast", "Steffisburg", "Gwatt", "Strättligen"] },
];

export const getCity = (slug) => cities.find((c) => c.slug === slug);
export const cityLabel = (c, lang) => (lang === "en" && c.nameEn ? c.nameEn : c.name);

export const weekdaysByLang = {
  de: ["Mo", "Di", "Mi", "Do", "Fr", "Sa"],
  en: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
};
